// extracted by mini-css-extract-plugin
module.exports = {"telegramContainer":"telegram_telegramContainer__2va98","light":"telegram_light__2Bk0f","textarea":"telegram_textarea__1PRjZ","list":"telegram_list__11P_Q"};